import { jsx as m } from "react/jsx-runtime";
import { c as _ } from "../clsx-OuTLNxxd.js";
const r = "TextStyle-module_container__RXujd",
  a = "TextStyle-module_font-size-small__jMfh6",
  x = "TextStyle-module_font-size-medium__NEpJi",
  c = "TextStyle-module_font-size-large__d913I",
  d = "TextStyle-module_font-size-disclaimer__yhhGT",
  f = "TextStyle-module_text-align-left__Fa-s4",
  S = "TextStyle-module_text-align-center__7uL4G",
  g = "TextStyle-module_text-align-right__Tc8y4",
  u = "TextStyle-module_is-responsive__f84mE",
  y = "TextStyle-module_is-boxed__qSIPX",
  e = {
    container: r,
    fontSizeSmall: a,
    fontSizeMedium: x,
    fontSizeLarge: c,
    fontSizeDisclaimer: d,
    textAlignLeft: f,
    textAlignCenter: S,
    textAlignRight: g,
    isResponsive: u,
    isBoxed: y
  },
  h = _ref => {
    let {
      boxed: l = !1,
      fontSize: t = "medium",
      textAlign: i,
      fontSizeResponsive: n = !1,
      className: o,
      children: s
    } = _ref;
    return /* @__PURE__ */m("div", {
      className: _(e.container, o, {
        [e.isBoxed]: l,
        [e.isResponsive]: n,
        [e.fontSizeSmall]: t == "small",
        [e.fontSizeMedium]: t == "medium",
        [e.fontSizeLarge]: t == "large",
        [e.fontSizeDisclaimer]: t == "disclaimer",
        [e.textAlignLeft]: i == "left",
        [e.textAlignCenter]: i == "center",
        [e.textAlignRight]: i == "right"
      }),
      children: s
    });
  };
export { h as TextStyle };